import React, { useEffect, useRef } from "react";
import { connect } from "react-redux";
import { Prompt, withRouter } from "react-router";
import classnames from "classnames";
import { toast } from "react-toastify";

import { getOnboardingPath } from "../../../../constants";
import {
  REMOVE_VALIDATIONS,
  VALIDATE_PRACTICEDETAILS,
} from "../../../../store/actions/actionTypes";
import * as actions from "../../../../store/actions";
import constants from "../../../../constants";
import "./stepTwo.css";

import Button from "../../../../components/formElements/button/Button";
import TextInput from "../../../../components/formElements/input/TextInput";
import Row from "../../../../components/uiElements/grid/Row";
import Card from "../../../../layout/Onboarding/Card";
import SearchLocationInput from "./AutoPlace/autoPlaceComp";
import AvailibilityCalendar from "./AvailibilityCalendar";
import ToggleButton from "../../../../components/formElements/toggle-button";
import OnboardingIcon from "../../../../components/uiElements/icons/onboardingIcons/OnboardingIcon";
import SelectInput from "../../../../components/formElements/selectInput/SelectInput";

const StepTwo = ({
  practiceDetails,
  setPracticeDetails,
  validateData,
  removeValidations,
  form,
  saveDoctorPracticeDetails,
  history,
  redirectedPath,
  updateDoctorPracticeDetails,
}) => {
  const myRef = useRef();

  const skillStyles = {
    multiValue: styles => {
      return {
        ...styles,
        background: "var(--pallet-color)",
      };
    },
    multiValueLabel: styles => ({
      ...styles,
      color: "white",
    }),
    multiValueRemove: styles => ({
      ...styles,
      color: "white",
      ":hover": {
        backgroundColor: "transparent",
      },
    }),
    placeholder: styles => ({
      ...styles,
      color: "#bbc1d0",
    }),
    dropdownIndicator: styles => ({
      ...styles,
      paddingRight: 25,
      display: "inline",
    }),
  };

  useEffect(() => {
    if (form && form.practiceDetailsValid) {
      if (
        redirectedPath ||
        (practiceDetails.dataLoaded && practiceDetails.dataChanged)
      ) {
        updateDoctorPracticeDetails(
          () =>
            practiceDetails.dataLoaded &&
            practiceDetails.dataChanged &&
            history.push(getOnboardingPath("/step3"))
        );
      } else {
        saveDoctorPracticeDetails(() =>
          history.push(getOnboardingPath("/step3"))
        );
      }
    } else if (form.practiceDetailsValid === false) {
      myRef?.current?.querySelector(":invalid")?.scrollIntoView({
        behavior: "smooth",
      });
    }
    form.practiceDetailsValid = false;
    form.slotsValid = false;
    // eslint-disable-next-line
  }, [form]);

  useEffect(() => {
    redirectedPath && setPracticeDetails({ dataChanged: false });
    redirectedPath && setPracticeDetails(practiceDetails.copy);
    removeValidations();
    // eslint-disable-next-line
  }, []);

  return (
    <>
      {redirectedPath && (
        <Prompt
          when={practiceDetails.dataChanged}
          message="You have unsaved changes, are you sure you want to leave?"
        />
      )}
      <div
        ref={myRef}
        className={classnames(
          "onboarding-container"
          // practiceDetails.dataLoaded && !redirectedPath && "disable"
        )}
      >
        <p className="onboarding-header">
          Practice
          <br /> Details
        </p>
        <Row>
          <Card bodyClass="">
            <TextInput
              error={form.practiceName}
              type="text"
              label="Practice Name"
              value={practiceDetails.practiceName}
              onChange={val => setPracticeDetails({ practiceName: val })}
            />
            <TextInput
              error={form.fees}
              type="currency"
              label="Fees"
              value={practiceDetails.fees}
              onChange={val => setPracticeDetails({ fees: val })}
            />
            <TextInput
              error={form.primaryPhone}
              type="number"
              maxLength={10}
              label="Primary Phone"
              value={practiceDetails.primaryPhone}
              onChange={val => setPracticeDetails({ primaryPhone: val })}
            />
            <div className="mt-n4 mb-5">
              <SelectInput
                error={form.primaryPhoneType}
                menuPlacement="auto"
                options={constants.PRIMARY_PHONE_TYPES}
                placeholder="Select Primary Phone Type"
                styles={skillStyles}
                value={practiceDetails.primaryPhoneType}
                onChange={val => setPracticeDetails({ primaryPhoneType: val })}
              />
            </div>
            <TextInput
              error={form.primaryFax}
              type="text"
              label="Primary Fax"
              value={practiceDetails.primaryFax}
              onChange={val => setPracticeDetails({ primaryFax: val })}
            />
          </Card>
          <Card bodyClass="" title="Practice Address">
            <TextInput
              type="text"
              label="Apt, Suite, Building (Optional)"
              value={practiceDetails.address2}
              onChange={val => setPracticeDetails({ address2: val })}
            />
            <SearchLocationInput
              error={practiceDetails.address1 ? undefined : form.address1}
              onSelect={setPracticeDetails}
              practiceDetails={practiceDetails}
            />
            <TextInput
              error={form.zipcode}
              type="text"
              label="Zipcode"
              value={practiceDetails.zipcode}
              disabled={
                practiceDetails.zipcodeFetched &&
                practiceDetails.zipcode &&
                true
              }
              onChange={val => {
                setPracticeDetails({ zipcode: val, zipcodeFetched: false });
              }}
            />
            <TextInput
              error={form.city}
              type="text"
              label="City"
              value={practiceDetails.city}
              disabled={
                practiceDetails.cityFetched && practiceDetails.city && true
              }
              onChange={val =>
                setPracticeDetails({ city: val, cityFetched: false })
              }
            />
            <TextInput
              error={form.state}
              type="text"
              label="State"
              value={practiceDetails.state}
              disabled={
                practiceDetails.stateFetched && practiceDetails.state && true
              }
              onChange={val =>
                setPracticeDetails({ state: val, stateFetched: false })
              }
            />
            <TextInput
              error={form.country}
              type="text"
              label="Country"
              value={practiceDetails.country}
              disabled={
                practiceDetails.countryFetched &&
                practiceDetails.country &&
                true
              }
              onChange={val =>
                setPracticeDetails({ country: val, countryFetched: false })
              }
            />
          </Card>
          <Card
            bodyClass="col-md-12 "
            childComponent={(
              <div className="child-div-container col-md-6 mb-5">
                <h6 className={classnames("header-availibility-calender header text-left mb-5 mt-n4")}>Set Availability Calendar</h6>
                <ToggleButton
                  onChange={() => setPracticeDetails({
                    ...practiceDetails, 
                    visit_now_doctor_status: !practiceDetails.visit_now_doctor_status,
                    dataChanged: true
                   })}
                  left_label={"Visit Now"}
                  disabled={!redirectedPath && practiceDetails.visit_now_doctor_status && practiceDetails?.dataLoaded}
                  is_toggled={practiceDetails.visit_now_doctor_status}
                  inputClassName={"card-toggle-button"}
                  containerClassName={"toggle-button-container"}
                />
              </div>
            )}
          >
            {!practiceDetails.visit_now_doctor_status && <AvailibilityCalendar />}
          </Card>
          {!redirectedPath ? (
            <Button
              type="secondary"
              indicatorButton
              className={classnames(
                "float-right next-button",
                practiceDetails.dataLoaded && "enable"
              )}
              onClick={() =>
                practiceDetails.dataLoaded && !practiceDetails.dataChanged
                  ? history.push(getOnboardingPath("/step3"))
                  : validateData(practiceDetails)
              }
              label={<OnboardingIcon type="nextButton" />}
            />
          ) : (
            <Button
              type="info"
              disabled={!practiceDetails.dataChanged && true}
              className={classnames("w-75 mx-auto mb-4")}
              onClick={() => validateData(practiceDetails)}
              label={"Save Changes"}
            />
          )}
        </Row>
      </div>
    </>
  );
};

const mapStoreToProps = ({ onboarding, validation, auth }) => ({
  practiceDetails: onboarding.practiceDetails,
  form: validation.data,
  redirectedPath: auth.redirectToOnboardingPath,
});

const mapDispatchToProps = dispatch => ({
  setPracticeDetails: updatedData =>
    dispatch(actions.setPracticeDetails(updatedData)),
  addSlots: period => dispatch(actions.addSlots(period)),
  setSlots: (period, updatedData, index) =>
    dispatch(actions.setSlots(period, updatedData, index)),
  removeSlots: (period, index) => dispatch(actions.removeSlots(period, index)),
  validateData: practiceDetails =>
    dispatch(actions.validateData(VALIDATE_PRACTICEDETAILS, practiceDetails)),
  removeValidations: () =>
    dispatch(actions.validateData(REMOVE_VALIDATIONS, {})),
  saveDoctorPracticeDetails: cb =>
    dispatch(actions.saveDoctorPracticeDetails(cb)),
  updateDoctorPracticeDetails: cb =>
    dispatch(actions.updateDoctorPracticeDetails(cb)),
});

export default withRouter(
  connect(mapStoreToProps, mapDispatchToProps)(StepTwo)
);
